import { Maybe, NamedUser } from "generated/graphql";

export function fullName(namedUser: Pick<NamedUser, "firstName" | "lastName">): string {
  return fullNameFromParts(namedUser.firstName, namedUser.lastName);
}

export function fullNameFromParts(firstName: string | undefined, lastName: string | undefined): string {
  return `${firstName || ""} ${lastName || ""}`.trim();
}

export function nameInitials(namedUser: Maybe<Pick<NamedUser, "firstName" | "lastName">> | undefined): string {
  return `${namedUser?.firstName[0] ?? ""}${namedUser?.lastName[0] ?? ""}`;
}
